function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCustomerPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 64,
    viewBox: "0 0 28.47 47.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M269.23,246.78c.21.09.6.16.61.26.24,4.13.66,8.29-2.11,11.9-1.48,5.15-4.54,9.66-6.14,14.79-.69,2.23-2.36,4.17-3.59,6.24h-3c-.17-.54-.36-1.06-.5-1.61s-.17-.89-.25-1.34l2.91-1c-.13-2.05,1.74-3.23,2.26-4.92.81-2.62,2.27-4.92,3.14-7.5s2.49-5.08,3.65-7.65c1.24-2.72,2.67-5.42,2.3-8.58C268.49,247.19,269,247,269.23,246.78Z",
    transform: "translate(-241.55 -232.71)",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.23,246.78c-.25.19-.74.41-.72.57.37,3.16-1.06,5.86-2.3,8.58s-2.74,5-3.65,7.65-2.33,4.88-3.14,7.5c-.52,1.69-2.39,2.87-2.26,4.92l-2.91,1a39.72,39.72,0,0,1-4.58-9.17c-.95-3-2.73-5.74-4.09-8.61a20.86,20.86,0,0,1-1.21-3.2,27,27,0,0,0-1.53-3c-2-4.38-1.48-8.61.23-12.81.51-1.26,1.26-2.8,2.35-3.37,2.13-1.12,3.5-3.75,6.43-3.33,1.26-1,2.75-.84,4.16-.69a14.33,14.33,0,0,1,4.06,1,24.66,24.66,0,0,1,3.88,2.31,3.94,3.94,0,0,1,1.31,1.29,79.35,79.35,0,0,1,3.94,7.95A4.17,4.17,0,0,1,269.23,246.78Zm-3,.92c0-.94,0-1.31,0-1.67.25-4.82-2.42-7.89-6.29-10.23-1.87-1.13-4-.76-6-.83a8.56,8.56,0,0,0-7.62,3.91c-2.81,4.27-3.65,8.87-1.46,13.94a49.21,49.21,0,0,1,2.78,6.61c.66,2.46,2.19,4.71,3.24,7.11s2.46,4.87,3.38,7.44a5.08,5.08,0,0,0,.5.83c.33-.24.8-.4,1-.72,1.94-3.61,3.32-7.47,5.14-11.15,1.35-2.72,2.69-5.5,3.83-8.35C265.67,252.17,266.79,249.83,266.23,247.7Z",
    transform: "translate(-241.55 -232.71)",
    style: {
      fill: "#37524b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.23,247.7c.56,2.13-.56,4.47-1.53,6.89-1.14,2.85-2.48,5.63-3.83,8.35-1.82,3.68-3.2,7.54-5.14,11.15-.17.32-.64.48-1,.72a5.08,5.08,0,0,1-.5-.83c-.92-2.57-2.3-5-3.38-7.44s-2.58-4.65-3.24-7.11a49.21,49.21,0,0,0-2.78-6.61c-2.19-5.07-1.35-9.67,1.46-13.94a8.56,8.56,0,0,1,7.62-3.91c2,.07,4.13-.3,6,.83,3.87,2.34,6.54,5.41,6.29,10.23C266.21,246.39,266.23,246.76,266.23,247.7Zm-4.49-.28c0-1.72,0-3.44,0-5.16-.05-1.57-.74-1.88-2.22-2.2-1.18-.25-1.66,1.4-3,.58a6.82,6.82,0,0,0-3.14-.47,5.05,5.05,0,0,0-2.41.48,6.1,6.1,0,0,0-3.35,3.07c-.63,1.6-1.47,3.32-.2,5.3.82,1.29.72,2.94,2.62,3.75,1.53.65,3,1.86,4.63,1.32a5.51,5.51,0,0,1,4.31,0c1.66.71,2.7-.36,2.75-2.21C261.77,250.37,261.74,248.9,261.74,247.42Z",
    transform: "translate(-241.55 -232.71)",
    style: {
      fill: "#66c749"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,247.42c0,1.48,0,3,0,4.42-.05,1.85-1.09,2.92-2.75,2.21a5.51,5.51,0,0,0-4.31,0c-1.68.54-3.1-.67-4.63-1.32-1.9-.81-1.8-2.46-2.62-3.75-1.27-2-.43-3.7.2-5.3a6.1,6.1,0,0,1,3.35-3.07,5.05,5.05,0,0,1,2.41-.48,6.82,6.82,0,0,1,3.14.47c1.33.82,1.81-.83,3-.58,1.48.32,2.17.63,2.22,2.2C261.78,244,261.74,245.7,261.74,247.42Zm-4.49-.83c0-.6,0-1.22,0-1.82a3.5,3.5,0,0,0-.36-.94c-1.23.79-2-1.24-3.59-.3-3.19,1.85-3.18,3.92-1,6.19,1.19,1.22,2.58.88,3.76.65s1.33-1.53,1.19-2.68A10.09,10.09,0,0,1,257.25,246.59Z",
    transform: "translate(-241.55 -232.71)",
    style: {
      fill: "#2b442b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25,246.59a10.09,10.09,0,0,0,0,1.1c.14,1.15,0,2.46-1.19,2.68s-2.57.57-3.76-.65c-2.2-2.27-2.21-4.34,1-6.19,1.61-.94,2.36,1.09,3.59.3a3.5,3.5,0,0,1,.36.94C257.29,245.37,257.25,246,257.25,246.59Z",
    transform: "translate(-241.55 -232.71)",
    style: {
      fill: "#66c749"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCustomerPin);
export default __webpack_public_path__ + "static/media/activeCustomerPin.1abb92717e6212bae24597dcb767199a.svg";
export { ForwardRef as ReactComponent };